/**
 * Namuna rejimi.
 *
 * Panelni ISHLAYOTGAN serversiz ochish uchun: dizaynni ko'rish,
 * xodimga ko'rsatish yoki interfeysni sinash uchun o'n sakkizta
 * servis va baza ko'tarish talab qilish ishni imkonsiz qilardi.
 *
 * Bayroq `localStorage` da: u ilova yuklanishidan OLDIN kerak
 * (kirish ekrani ham unga qarab o'zgaradi) va sahifa
 * yangilanganda saqlanib qolishi lozim.
 */
const KEY = "uyda.mock";

/**
 * Namoyish qurilishi.
 *
 * `VITE_UYDA_DEMO=1` bilan yig'ilgan paketda namuna rejimi
 * BOSHIDAN yoqilgan bo'ladi: buyurtmachiga ko'rsatish uchun
 * tayyorlangan faylni ochgan odam avval kalitni topib, keyin
 * yoqishi kerak bo'lmasin.
 *
 * Tanlov baribir qoladi — kalit kirish ekranida turadi va
 * o'chirilgani saqlanadi.
 */
const DEMO_BUILD = import.meta.env.VITE_UYDA_DEMO === "1";

export function isMockMode(): boolean {
  try {
    const stored = localStorage.getItem(KEY);
    // Aniq tanlov har doim ustun: namoyish paketida ham
    // foydalanuvchi rejimni o'chira oladi.
    if (stored !== null) return stored === "1";
    return DEMO_BUILD;
  } catch {
    return DEMO_BUILD;
  }
}

export function setMockMode(enabled: boolean): void {
  try {
    // O'chirish ham ANIQ yoziladi ("0"), o'chirib tashlash
    // emas: namoyish paketida yozuvning yo'qligi «yoqilgan»
    // degani va o'chirish darhol qaytib kelardi.
    localStorage.setItem(KEY, enabled ? "1" : "0");
  } catch {
    /* e'tiborsiz */
  }
}

/** Namoyish uchun yig'ilgan paketmi. */
export function isDemoBuild(): boolean {
  return DEMO_BUILD;
}
